import { render } from "./ArrowButton.vue?vue&type=template&id=ea207bfc&ts=true"
import script from "./ArrowButton.vue?vue&type=script&lang=ts"
export * from "./ArrowButton.vue?vue&type=script&lang=ts"

import "./ArrowButton.vue?vue&type=style&index=0&id=ea207bfc&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__